import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IntegratorTokenStore } from './integrator-token.store';

@Injectable()
export class IntegratorTokenInterceptor implements HttpInterceptor {
  constructor(private readonly tokenStore: IntegratorTokenStore) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenStore.getToken();
    const isLibraryApi = req.url.includes('/api/library/');

    if (token && isLibraryApi && !req.headers.has('Token')) {
      req = req.clone({
        setHeaders: { Token: token },
      });
    }

    return next.handle(req);
  }
}
